// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TfSE","select":"styles_select__10qip"};